<h2>Buscar por capital</h2>
<hr class="bg-info" />

<div class="row">
  <div class="col">
    <app-pais-input
      (onEnter)="buscar($event)"
      (onDebounce)="sugerencias($event)"
      placeHolder="Buscar por capital..."
    ></app-pais-input>
  </div>
</div>

<ul class="list-group" *ngIf="mostrarSugerencias">
  <li
    *ngFor="let pais of paisesSugeridos"
    class="list-group-item list-group-item-action"
  >
    <a class="nav-link text-info" [routerLink]="['/pais', pais.alpha2Code]">
      {{ pais.name }}
    </a>
  </li>
  <li class="list-group-item list-group-item-action">
    <a class="nav-link text-info" (click)="buscarSugerido(termino)">
      Buscar "{{ termino }}"
    </a>
  </li>
</ul>

<hr />

<div *ngIf="hayError" class="alert alert-danger">
  No se encontro nada con el termino {{ termino | titlecase }}
</div>

<div *ngIf="paises.length > 0" class="row">
  <div class="col">
    <app-pais-table [paises]="paises" class="table-responsive"></app-pais-table>
  </div>
</div>
